export default class State {
  geolocation = false;
}
